import React, { useEffect, useRef, useState } from "react";
import { Form, Select, Button, DatePicker, Radio, Input, Spin } from "antd";
import {

  mobilePattern,
  emailPattern,
  dispatchtoast,

} from "../../../utils";
import { userRegister } from "../../../ApiServices/Apifun";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import { images } from "../../../assets/images";




const Register = () => {
  const formRef = useRef();
  const [form] = Form.useForm();
  const [membercustomPayload, setCustomMemberPayload] = useState({});
  const [country, setCountry] = useState([]);
  const [loader, setloader] = useState(false);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [packages, setPackages] = useState([]);
  //   const [selectedMember, setSelectedMember] = useState(null);
  const [memberType, setMemberType] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFinish = (val) => {
    // Prepare the payload as a JSON object
    const payload = {
      mobile_number: val.mobile_number,
      email: val.email,
      name: val.name,
      password: val.password,
    };

    // Call the API with JSON data
    userRegister(payload)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message); // Display success message
          setloader(false)
          navigate("/admin"); // Redirect to home page
        }
        else {
          setloader(true)
        }
      })
      .catch((err) => { console.error(err); setloader(false) }); // Handle error
  };
  return (
    <>
      <div className=" bg-blue-100 h-screen ">
        <div className="grid grid-cols-1 md:grid-cols-2  w-full h-screen md:h-full  place-items-center">
          <div className="h-full      w-full px-10 flex flex-col justify-center items-center">
            <div className="flex justify-center items-center">
              <img
                src={images.WebsiteLogo}
                style={{ filter: "drop-shadow(0px 1px 2px #cfc5c5)" }}
              />
            </div>
            <p className="text-black mt-10 font-[100] text-4xl">Welcome to</p>
            <p className="mt-6 text-3xl font-semibold text-black">
              Restrurant Management
            </p>
            <p className="text-xs font-normal text-black mt-4">
              Bunch of all business solution logic
            </p>
            <img
              src={images.login}
              className="w-[300px] h-[200px] mt-4 m-4"
            />
          </div>
          <div className="bg-gray-100 p-8 h-screen  overflow-y-scroll shadow-lg shadow-gray-500 rounded-md">
            {/* <div className="flex justify-center items-center">
      <img
                src={Images.WebsiteLogo}
                style={{ filter: "drop-shadow(0px 1px 2px #cfc5c5)" }}
              />
      </div> */}
            <div className="p-4 ">
              <Form
                form={form}
                ref={formRef}
                name="basic"
                initialValues={{
                  remember: true,
                }}
                onFinishFailed={(err) => console.log(err)}
                onFinish={(val) => handleFinish(val)}
              >
                {/* <p className="text-md text-primary font-semibold">Add Member</p> */}
                <p className="mt-4 font-semibold">Member Details</p>
                <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-x-5">
                  <Form.Item
                    name={`name`}
                    label={"Name"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Name!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Your Name"
                      name="name"
                    />
                  </Form.Item>

                  <Form.Item
                    name={`mobile_number`}
                    label={"Mobile"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter your Mobile Number!",
                      },
                      {
                        pattern: mobilePattern,
                        message: "Invalid mobile number!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Your Mobile"
                      name="mobile_number"
                    />
                  </Form.Item>{" "}
                  <Form.Item
                    name={`email`}
                    label={"Email"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter your Email!",
                      },
                      {
                        pattern: emailPattern,
                        message: "Enter Valid Email!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Your Email "
                      name="email"
                    />
                  </Form.Item>{" "}
                  <Form.Item
                    name={`password`}
                    label={"Password"}
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Enter Password!",
                      },
                      {
                        // pattern: pincodePattern,
                        message: "Invalid Password format!",
                      },
                      {
                        whitespace: true,
                        message: "Field cannot contain only blank spaces",
                      },
                    ]}
                  >
                    <CommonInput
                      placeholder="Enter Your Password"
                      name="password"
                    />
                  </Form.Item>



                </div>

                <div className="flex justify-start items-center mt-2">
                  <Form.Item>
                    <Button
                      loading={loader}
                      htmlType="submit"
                      className="bg-primary outline-none border-none text-white"
                    >
                      Save
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Register;
